module.exports = __webpack_public_path__ + "img/邻里中心.3f39c4a2.png";